import React, { useMemo, useRef } from 'react';
import LineView from './LineView';
import _ from 'lodash';
import PropTypes from 'prop-types';

const createLineData = (laneNumber, graphDataPackage) => {
  if (!graphDataPackage) {
    return null;
  }

  const filteredData = _.filter(graphDataPackage.data, { laneNumber });

  if (filteredData.length === 0) {
    return null;
  }

  const filteredSignalSets = graphDataPackage.signalSets.map(signalSet => {
    const newSignals = signalSet.signals.filter(signal => {
      return _.some(filteredData, ({ assetId, name }) => assetId === signalSet.assetId && name === signal.name);
    });

    return {
      ...signalSet,
      signals: newSignals
    };
  });

  const colors = _.flatten(filteredSignalSets.map(signalSet => signalSet.signals.map(signal => signal.color)));
  return {
    ...graphDataPackage,
    data: filteredData,
    signalSets: filteredSignalSets,
    colors
  };
};

const MultiLineGraphView = ({ graphDataPackage, dataOptions, resetZoom, setResetZoom, size }) => {
  const laneChangeCounter = useRef({ count: 0, laneCount: 0 });
  const lineData = useMemo(() => {
    const lanes = _.uniq(_.map(graphDataPackage?.data, 'laneNumber')?.sort());
    if (lanes.length !== laneChangeCounter.current.laneCount) {
      laneChangeCounter.current = { count: laneChangeCounter.current.count + 1, laneCount: lanes.length };
    }
    return _.compact(_.map(lanes, lane => createLineData(lane, graphDataPackage)));
  }, [graphDataPackage]);

  const displayChartGraphComponent = _.map(lineData, (lane, index) => {
    return (
      <LineView
        key={'line_' + index + '_count_' + laneChangeCounter.current.count}
        graphDataPackage={lane}
        reflowTrigger={size.width + size.height + laneChangeCounter.current.count}
        setResetZoom={setResetZoom}
        timespan={dataOptions?.timespan}
        resetZoom={resetZoom}
      />
    );
  });

  return (<>{ displayChartGraphComponent }</>);
};

MultiLineGraphView.propTypes = {
  graphDataPackage: PropTypes.object,
  dataOptions: PropTypes.object,
  resetZoom: PropTypes.bool,
  setResetZoom: PropTypes.func,
  size: PropTypes.shape({ width: PropTypes.number, height: PropTypes.number })
};

export default MultiLineGraphView;
